export default "/img/NE.a52ef90bbc37cf16b9cd99770661e18f.png";